import React, { memo } from 'react';
import ChannelCardV2 from '../../../components/cardsV2/channel/ChannelCardV2';
import ClinicalVideoCardV2 from '../../../components/cardsV2/clinicalVideo/ClinicalVideoCardV2';
import CourseCardV2 from '../../../components/cardsV2/course/CourseCardV2';
import DoctorCardV2 from '../../../components/cardsV2/doctor/DoctorCardV2';
import EbookCardV2 from '../../../components/cardsV2/ebook/EbookCardV2';
import LiveCmeCardV2 from '../../../components/cardsV2/liveCme/LiveCmeCardV2';
import MedwikiCardV2 from '../../../components/cardsV2/medwiki/MedwikiCardV2';
import SPQ from '../../../components/cardsV2/spq/SPQ';
import GrCardV1 from '../../../components/cards/grandRound/grCardV1/GrCardV1';
const Cards = ({ type, data }) => {
  console.log('from card', data);
  const specialityArrayToString = (specialities_ids_and_names) => {
    if (specialities_ids_and_names && specialities_ids_and_names?.length > 0) {
      let names = specialities_ids_and_names?.map((_s) => _s.name);
      return names.join();
    } else {
      return '';
    }
  };
  switch (type) {
    case 'comp': {
      let { type_id, question, specialities_ids_and_names, specialities, deeplink, image } = data;
      return (
        <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">
          <MedwikiCardV2
            gtmTagVariable="gtm_cl_searchResult"
            id={type_id}
            image={image}
            title={question}
            url={deeplink}
            specialities={specialityArrayToString(specialities_ids_and_names)}
            specialities_ids_and_names={specialities_ids_and_names}
          />
        </div>
      );
    }
    case 'video_archive': {
      let { type_id, question, specialities, specialities_ids_and_names, deeplink, image } = data;
      return (
        <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">
          <ClinicalVideoCardV2
            gtmTagVariable="gtm_cl_searchResult"
            id={type_id}
            image={image}
            title={question}
            url={deeplink}
            specialities={specialityArrayToString(specialities_ids_and_names)}
            data={data}
            specialities_ids_and_names={specialities_ids_and_names}
          />
        </div>
      );
    }
    case 'session':
      let {
        session_id,
        session_topic,
        deeplink,
        start_datetime,
        ms_cat_name,
        session_doctor_entities,
        session_status
      } = data;
      return (
        <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">
          <LiveCmeCardV2
            gtmTagVariable="gtm_cl_searchResult"
            id={session_id}
            title={session_topic}
            url={deeplink}
            startDate={start_datetime}
            category={ms_cat_name}
            session_doctor_entities={session_doctor_entities}
            session_status={session_status}
          />
        </div>
      );
    case 'gr':
      return (
        <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">
          <GrCardV1 cardData={data} />
        </div>
      );
    case 'survey': {
      let {
        survey_id,
        survey_title,
        survey_description,
        point,
        image,
        deeplink,
        category,
        specialities_name,
        specialities_ids_and_names
      } = data;
      return (
        <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">
          <SPQ
            gtmTagVariable="gtm_cl_searchResult"
            id={survey_id}
            title={survey_title}
            image={image}
            point={point}
            url={deeplink}
            description={survey_description}
            category={category}
            specialities={specialities_name}
            specialities_ids_and_names={specialities_ids_and_names}
          />
        </div>
      );
    }
    case 'training': {
      let { id, title, duration, module_Count, deeplink, image, specialities_ids_and_names } = data;
      return (
        <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">
          <CourseCardV2
            gtmTagVariable="gtm_cl_searchResult"
            id={id}
            title={title}
            duration={duration}
            module_count={module_Count}
            url={deeplink}
            image={image}
            specialities_ids_and_names={specialities_ids_and_names}
          />
        </div>
      );
    }
    case 'profile_doctor': {
      const { doctor_id, doctor_name, subtitle, profile, profile_image } = data;
      return (
        <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">
          <DoctorCardV2
            gtmTagVariable="gtm_cl_searchResult"
            doctor_id={doctor_id}
            doctor_name={doctor_name}
            subtitle={subtitle}
            profile={profile}
            profile_image={profile_image}
          />
        </div>
      );
    }
    case 'channel':
      return (
        <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">
          <ChannelCardV2 />
        </div>
      );
    case 'epub': {
      let { type_id, title, image } = data;

      return (
        <div className="col-xxl-3 col-lg-4 col-md-6 col-12 mt-4 ps-4 mt-md-5 ps-md-5 pe-0">
          <EbookCardV2
            gtmTagVariable="gtm_cl_searchResult"
            id={type_id}
            title={title}
            image={image}
          />
        </div>
      );
    }
    default:
      return <></>;
  }
};

export default memo(Cards);
